<div class="portfolio-switcher">
    <div *ngIf="authService.merchants.length > 0 && authService.activeMerchant" class="dropdown w-100">
        <button
            *ngIf="authService.merchants.length > 1; else onlyOne"
            class="switcher-toggle dropdown-toggle w-100"
            type="button"
            id="merchantDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
        >
            <div class="switcher-content">
                <div class="switcher-name">
                    <i class="fa-solid fa-building me-2"></i>
                    {{ this.authService.activeMerchant.companyName }}
                </div>
                <span *ngIf="authService.activeMerchant" class="portfolio-badge" [ngClass]="getPortfolioTypeClass(authService.activeMerchant)">
                    {{ getPortfolioType(authService.activeMerchant) }}
                </span>
            </div>
        </button>

        <ng-template #onlyOne>
            <div class="switcher-single">
                <span class="switcher-name">
                    {{ this.authService.activeMerchant.companyName }}
                </span>
                <span *ngIf="authService.activeMerchant" class="portfolio-badge" [ngClass]="getPortfolioTypeClass(authService.activeMerchant)">
                    {{ getPortfolioType(authService.activeMerchant) }}
                </span>
            </div>
        </ng-template>

        <ul *ngIf="authService.merchants.length > 1" class="switcher-menu dropdown-menu w-100" aria-labelledby="merchantDropdown">
            <ng-container *ngFor="let merchant of authService.merchants">
                <li *ngIf="merchant.companyName != authService.activeMerchant.companyName">
                    <a class="switcher-item" (click)="authService.setActiveMerchant(merchant)">
                        <span>{{ merchant.companyName }}</span>
                        <span class="portfolio-badge" [ngClass]="getPortfolioTypeClass(merchant)">
                            {{ getPortfolioType(merchant) }}
                        </span>
                    </a>
                </li>
            </ng-container>
        </ul>
    </div>
</div>
<div class="switcher-divider"></div>
